import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class ColoracaoService extends Service{

  protected url: string = this.dominio+"/adm/laudos-cd/coloracao/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-coloracao/coloracao.service.ts